<div class="avi-data-grid clr-wrapper">
    <clr-datagrid
        *ngIf="afterViewInit"
        [ngClass]="{ 'datagrid-compact': layout.compact }"
        [clrDgSelected]="selected"
        (clrDgSelectedChange)="selectionChanged($event)"
        (clrDgRefresh)="refresh($event)"
        [clrDgLoading]="isLoading"
        cdkDropList
        [cdkDropListDisabled]="!layout.withReordering"
        (cdkDropListDropped)="emitRowOrderChange($event)"
    >
        <clr-dg-action-bar class="avi-data-grid__action-bar grid-container">
            <div class="avi-data-grid__action-bar-left-actions grid-container__cell--w--6">
                <ng-content select="avi-data-grid_actions"></ng-content>
                <div
                    *ngIf="multipleactions?.length && selected?.length"
                    class="btn-group avi-data-grid__btn-group"
                >
                    <cds-button
                        class="avi-data-grid__multipleaction-button sel-multipleaction-button"
                        *ngFor="let action of multipleactions; trackBy: trackByActionLabel"
                        [disabled]="isMultipleActionDisabled(action)"
                        size="sm"
                        action="outline"
                        (click)="callMultipleaction(action)"
                    >
                        <span>{{ action.label }}</span>
                    </cds-button>
                </div>
            </div>
            <div
                *ngIf="hasSearch"
                class="avi-data-grid__action-bar-search-container grid-container__cell--w--6"
            >
                <button
                    *ngIf="!showSearchBar"
                    type="button"
                    (click)="expandSearchBar()"
                    class="search-icon sel-search-button avi-data-grid__search-button"
                >
                    <cds-icon
                        class="avi-data-grid__action-bar-search-icon"
                        shape="search"
                        size="19"
                    ></cds-icon>
                </button>
                <ng-container *ngIf="showSearchBar">
                    <form
                        clrForm
                        class="avi-data-grid__action-bar-search-input"
                        #searchForm="ngForm"
                    >
                        <cds-search
                            layout="horizontal"
                        >
                            <!-- Empty label element placeholder required by cds-search component -->
                            <label></label>
                            <input
                                type="search"
                                id="search-input"
                                class="grid-search-input sel-avi-data-grid-search-input"
                                #searchInput
                                [placeholder]="searchInputPlaceholder"
                                name="searchValue"
                                [(ngModel)]="searchValue"
                                (ngModelChange)="search()"
                            />
                        </cds-search>
                    </form>
                    <button
                        type="button"
                        (click)="clearSearch()"
                        class="sel-search-clear-button avi-data-grid__action-bar-search-clear-icon"
                    >
                        <cds-icon
                            class="avi-data-grid__search-clear-icon"
                            shape="times-circle"
                            size="20"
                        ></cds-icon>
                    </button>
                </ng-container>
            </div>
        </clr-dg-action-bar>
        <clr-dg-column
            *ngIf="layout.withReordering"
            [style.minWidth.px]="iconWidth"
            [style.width.px]="iconWidth"
            cdkDropList
        ></clr-dg-column>
        <clr-dg-column
            *ngFor="let field of filteredFields; trackBy: trackByFieldId"
            [clrDgSortBy]="getSortingComparator(field)"
            cdkDropList
        >
            <cds-icon
                *ngIf="field.icon"
                class="avi-data-grid__field-header-icon"
                shape="{{ field.icon }}"
                size="{{ field.iconSize ?? '16' }}"
            ></cds-icon>
            <ng-container
                *ngIf="field.labelTooltipOptions; then labelWithTooltip; else labelOnly">
            </ng-container>
            <clr-dg-filter
                *ngIf="field.columnFilterTemplateRef"
                id="avi-grid-filter-tooltip"
                avi-tooltip
                [showOnClick]="true"
                [tooltipControl$]="filterTooltipVisibilitySubject$.asObservable()"
                [positionsPriority]="filterTooltipPositionsPriority"
                (onBackdropClick)="toggleFilterTooltip()"
                (click)="toggleFilterTooltip()"
            >
                <ng-template #aviTooltipContent>
                    <div
                        id="avi-data-grid-filter-tool-tip-content"
                        (click)="toggleFilterTooltip()"
                    >
                        <ng-container [ngTemplateOutlet]="field.columnFilterTemplateRef"></ng-container>
                    </div>
                </ng-template>
            </clr-dg-filter>
            <avi-data-grid-dropdown-filter
                *ngIf="field.columnDropdownFilter"
                [columnDropdownFilter]="field.columnDropdownFilter"
                class="avi-data-grid__avi-data-grid-dropdown-filter"
            ></avi-data-grid-dropdown-filter>
            <ng-template #labelOnly>
                {{ field.label }} {{ field.columnFilterTemplateRef ? '(' + (field.columnFilterState.label | async) + ')' : null }}
            </ng-template>
            <ng-template #labelWithTooltip>
                <label
                    class="avi-data-grid__field-label-with-tooltip"
                    aviLabelWithTooltip
                    [objectType]="field.labelTooltipOptions.objectType"
                    [fieldName]="field.labelTooltipOptions.fieldName"
                >
                    {{ field.label }} {{ field.columnFilterTemplateRef ? '(' + (field.columnFilterState.label | async) + ')' : null }}
                </label>
            </ng-template>
        </clr-dg-column>
        <clr-dg-column
            *ngIf="hasSingleactions"
            [style.minWidth.px]="singleactionsWidth"
            [style.maxWidth.px]="singleactionsWidth"
            cdkDropList
        ></clr-dg-column>
        <clr-dg-column
            *ngIf="showExpanderColumn"
            [style.minWidth.px]="iconWidth"
            [style.maxWidth.px]="iconWidth"
            cdkDropList
        >
            <cds-icon
                *ngIf="showGridExpander"
                class="avi-data-grid__icon"
                shape="angle"
                direction="{{ isGridExpanded ? 'up' : 'down' }}"
                size="14"
                (click)="toggleGridExpanded()"
            ></cds-icon>
        </clr-dg-column>
        <clr-dg-row
            *ngFor="let row of rows; index as i; trackBy: trackByRowId"
            [hidden]="!isGridExpanded"
            [clrDgItem]="row"
            [clrDgSelectable]="isRowSelectable(row)"
            class="avi-data-grid__row"
            [ngClass]="getRowClassNames(row, i)"
            cdkDrag
        >
            <clr-dg-cell
                *ngIf="layout.withReordering"
                class="avi-data-grid__singleaction-cell avi-data-grid__singleaction-cell--movable"
                [style.minWidth.px]="iconWidth"
                cdkDragHandle
            >
                <cds-icon
                    class="avi-data-grid__icon avi-data-grid__icon--movable"
                    shape="drag-handle"
                    size="20"
                ></cds-icon>
            </clr-dg-cell>
            <clr-dg-cell
                *ngFor="let field of filteredFields; trackBy: trackByFieldId"
                class="{{'sel-avi-data-grid-cell-' + getFormattedFieldLabel(field.label)}}"
            >
                <div
                    *ngIf="field.transform && !field.getTooltip"
                    class="avi-data-grid__cell-transform"
                >
                    {{ field.transform(row) }}
                </div>
                <div
                    *ngIf="field.templateRef"
                    class="avi-data-grid__cell-transform"
                >
                    <ng-container
                        [ngTemplateOutlet]="field.templateRef"
                        [ngTemplateOutletContext]="{ $implicit: row, index: i, rows: rows, fieldId: field.id, data: field.data }"
                    ></ng-container>
                </div>
                <div *ngIf="field.transform && field.getTooltip">
                    <div
                        avi-tooltip
                        id="{{ field.id + '-tooltip' }}"
                        [showOnClick]="false"
                        [tooltipControl$]="columnTooltipControl$"
                        [positionsPriority]="tooltipPositions"
                        class="avi-data-grid__cell-transform"
                    >
                        {{ field.transform(row) }}
                        <ng-template #aviTooltipContent>
                            <div class="avi-data-grid-column-tooltip__panel clr-wrapper">
                                <div class="avi-data-grid-column-tooltip__content">
                                    <div class="avi-data-grid-column-tooltip__header">
                                        {{ field.getTooltip(row) }}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </clr-dg-cell>
            <clr-dg-cell
                *ngIf="hasSingleactions"
                class="avi-data-grid__singleaction-cell"
                [style.minWidth.px]="singleactionsWidth"
                [style.maxWidth.px]="singleactionsWidth"
            >
                <avi-dropdown-button
                    [hideCaret]="true"
                    [useIcon]="true"
                    [actions]="singleactionDropdownOptions"
                    [context]="row"
                    actionClassName="sel-singleaction-item"
                    id="sel-singleaction-item-list-icon"
                >
                    <cds-icon
                        shape="ellipsis-vertical"
                        size="sm"
                    ></cds-icon>
                </avi-dropdown-button>
            </clr-dg-cell>
            <clr-dg-cell
                *ngIf="showExpanderColumn"
                class="avi-data-grid__singleaction-cell"
                [style.minWidth.px]="iconWidth"
                [style.maxWidth.px]="iconWidth"
            >
                <ng-container *ngIf="showRowExpanders && !isRowExpanderDeactivated(row)">
                    <button
                        type="button"
                        class="avi-data-grid__expander-button sel-avi-data-grid-expander-button"
                        (click)="toggleRowExpanded(row)"
                    >
                        <cds-icon
                            class="avi-data-grid__icon"
                            shape="angle"
                            direction="{{ isRowExpanded(row) ? 'up' : 'down' }}"
                            size="14"
                        ></cds-icon>
                    </button>
                </ng-container>
            </clr-dg-cell>
            <clr-dg-row-detail
                *ngIf="isRowExpanded(row)"
                role="none"
                class="avi-data-grid__expanded-content"
                [ngClass]="{ 'avi-data-grid__column-based-expanded-content-row': config.isExpandedContentColumnBased && !config.expandedContentTemplateRef }"
            >
                <ng-container *ngIf="config.isExpandedContentColumnBased && !config.expandedContentTemplateRef">
                    <clr-dg-row *ngFor="let child of row.children; index as i; trackBy: trackByRowId">
                        <clr-dg-cell
                            *ngIf="layout.withReordering"
                            [style.minWidth.px]="iconWidth"
                        ></clr-dg-cell>
                        <clr-dg-cell *ngFor="let field of filteredFields; trackBy: trackByFieldId">
                            <div
                                *ngIf="field.expandedTransform"
                                class="avi-data-grid__cell-transform"
                            >
                                {{ field.expandedTransform(child) }}
                            </div>
                            <div *ngIf="field.expandedTemplateRef">
                                <ng-container
                                    [ngTemplateOutlet]="field.expandedTemplateRef"
                                    [ngTemplateOutletContext]="{ $implicit: child, index: i}"
                                ></ng-container>
                            </div>
                        </clr-dg-cell>
                        <clr-dg-cell
                            *ngIf="hasSingleactions"
                            [style.minWidth.px]="singleactionsWidth"
                            [style.maxWidth.px]="singleactionsWidth"
                        ></clr-dg-cell>
                        <clr-dg-cell
                            *ngIf="showExpanderColumn"
                            [style.minWidth.px]="iconWidth"
                            [style.maxWidth.px]="iconWidth"
                        ></clr-dg-cell>
                    </clr-dg-row>
                </ng-container>
                <ng-container
                    *ngIf="!config.isExpandedContentColumnBased && config.expandedContentTemplateRef"
                    [ngTemplateOutlet]="config.expandedContentTemplateRef"
                    [ngTemplateOutletContext]="{ $implicit: row, index: i }"
                ></ng-container>
            </clr-dg-row-detail>
        </clr-dg-row>
        <clr-dg-footer
            *ngIf="showFooter"
            class="avi-data-grid__footer"
        >
            <avi-data-grid-column-selection
                [fields]="fields"
                [showColumnHash]="columnVisibilityHash"
                (onShowColumnHashChange)="onColumnVisibilityHashChange($event)"
            ></avi-data-grid-column-selection>
            <clr-dg-pagination
                *ngIf="!hidePagination"
                #pagination
                [clrDgTotalItems]="rowsTotal"
                [clrDgPageSize]="pageSize"
                [clrDgPage]="currentPage"
            >
                <clr-dg-page-size [clrPageSizeOptions]="[10,20,30,50]">
                    {{ l10nKeys.itemsPerPageLabel | vtranslate }}
                </clr-dg-page-size>
                <ng-container *ngIf="!config.layout?.hideRowsTotal">
                    {{ rowsTotal }} {{ globalL10nKeys.totalLabel | vtranslate }}
                </ng-container>
            </clr-dg-pagination>
        </clr-dg-footer>
        <clr-dg-placeholder>
            {{ placeholderMessage }}
        </clr-dg-placeholder>
    </clr-datagrid>
</div>
